
export const groupCriterions = (criterions) => criterions?.map(({child_criterion_json, ...rest}) => ({...rest, criterions: child_criterion_json}))

// export const groupCriterions = (criterions, chapters) => {
  
//   if (!criterions) return null;
  
//   const groupedCriterions = criterions.reduce((acc, criterion) => {
//     if (acc.hasOwnProperty(criterion.chapter)) {
//       acc[criterion.chapter].push(criterion)
//     } else {
//       acc[criterion.chapter] = [criterion]
//     }
//     return acc
//   }, {})
  
//   const result = chapters.reduce((acc, chapter) => {
//     if (groupedCriterions.hasOwnProperty(chapter.value)) {
//       acc.push({
//         name: chapter.name,
//         criterions: groupedCriterions[chapter.value]
//       })
//     }
//     return acc
//   }, [])
  
//   return result
// }